/** iOS 底部安全区在系统值基础上减去的 px */
export const IOS_BOTTOM_SAFE_SUBTRACT_PX = 20;

/** 业务使用的自定义底部安全区高度变量名（值在各项目 global.css :root 定义） */
export const BOTTOM_SAFE_HEIGHT_VAR = "--lf-bottom-safe-height";

/** 在 calc / height 中引用自定义变量 */
export const bottomSafeHeightRef = `var(${BOTTOM_SAFE_HEIGHT_VAR}, 0px)`;

export type MobileOsKind = "ios" | "android" | "other";

export function detectMobileOs(): MobileOsKind {
  const ua = navigator.userAgent;
  const isIos =
    /iPad|iPhone|iPod/.test(ua) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  if (isIos) {
    return "ios";
  }
  if (/Android/i.test(ua)) {
    return "android";
  }
  return "other";
}

export function mobileOsHtmlClass(os: MobileOsKind): string {
  return `lf-os-${os}`;
}
